export default __webpack_public_path__ + "static/media/adoptzi_step3.bce28b07.png";